import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IRealEstate, ISelfManagedTeam } from './interfaces';

export const getSelfManagedTeamList = (data: IDynamicTableParams) => {
  return instance()
    .post<ISelfManagedTeam[]>('/selfManagedTeam/list', data)
    .then((response) => response.data);
};

export const getSelfManagedTeamListAll = () => {
  return instance()
    .post<ISelfManagedTeam[]>('/selfManagedTeam/listAll')
    .then((response) => response.data);
};

export const getSelfManagedTeamListAllNotDeleted = () => {
  return instance()
    .post<ISelfManagedTeam[]>('/selfManagedTeam/listAllNotDeleted')
    .then((response) => response.data);
};

export const getSelfManagedTeamAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/selfManagedTeam/availableColumns')
    .then((response) => response.data);
};

export const getSelfManagedTeamAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/selfManagedTeam/availableGroupColumns')
    .then((response) => response.data);
};

export const loadSelfManagedTeam = (id: number) => {
  return instance()
    .get<ISelfManagedTeam>(`/selfManagedTeam/load/${id}`)
    .then((response) => response.data);
};

export const createSelfManagedTeam = (team: ISelfManagedTeam) => {
  return instance()
    .post<ISelfManagedTeam>('/selfManagedTeam/save', team)
    .then((response) => response.data);
};

export const updateSelfManagedTeam = (team: ISelfManagedTeam) => {
  return instance()
    .post<ISelfManagedTeam>(`/selfManagedTeam/${team.selfManagedTeamId}/update`, team)
    .then((response) => response.data);
};

export const archiveSelfManagedTeam = (selfManagedTeamId: number) => {
  return instance()
    .post('/selfManagedTeam/archive', { selfManagedTeamId })
    .then((response) => response.data);
};

export const recoverSelfManagedTeam = (selfManagedTeamId: number) => {
  return instance()
    .post('/selfManagedTeam/recover', { selfManagedTeamId })
    .then((response) => response.data);
};

export const getRealEstatesShort = (
  data: { searchWithCity?: boolean; nameWithCity?: boolean } = {
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};